// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Launchpad Management */
.launchpad-page .dashboard-body {
  padding-bottom: 2rem;
}

.launchpad-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 1rem;
  margin-bottom: 1.5rem;
}

.launchpad-card {
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 12px;
  padding: 1.25rem;
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 0.5rem;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);
}

.launchpad-card i {
  font-size: 1.5rem;
  color: var(--text-muted);
}

.launchpad-card__value {
  font-size: 1.5rem;
  font-weight: 700;
  color: #0f766e;
}

.launchpad-card__label {
  font-size: 0.85rem;
  color: var(--text-muted);
}

.launchpad-tabs {
  display: flex;
  gap: 0.25rem;
  margin-bottom: 1.5rem;
  flex-wrap: wrap;
}

.launchpad-tab {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.85rem 1.5rem;
  font-size: 0.95rem;
  font-weight: 600;
  font-family: inherit;
  color: var(--text-muted);
  background: #fff;
  border: 1px solid var(--border);
  border-radius: 10px;
  cursor: pointer;
  transition: all 0.2s;
}

.launchpad-tab:hover {
  color: #0f766e;
  border-color: #0f766e;
  background: #f0fdfa;
}

.launchpad-tab--active {
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  border-color: transparent;
}

.launchpad-content {
  background: #fff;
  border-radius: 12px;
  border: 1px solid var(--border);
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  overflow: hidden;
}

.launchpad-section {
  padding: 1.5rem;
}

.launchpad-section__title {
  margin: 0 0 1.25rem;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.launchpad-section__title i {
  color: #0f766e;
}

/* Launchpad List sub-tabs (Upcoming, Pending, Ended) */
.launchpad-list-tabs {
  display: flex;
  gap: 0.5rem;
  margin-bottom: 1.25rem;
  flex-wrap: wrap;
}

.launchpad-list-tab {
  padding: 0.6rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  color: var(--text-muted);
  background: #f8fafc;
  border: 1px solid var(--border);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
}

.launchpad-list-tab:hover {
  color: #0f766e;
  border-color: #0f766e;
  background: #f0fdfa;
}

.launchpad-list-tab--active {
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  border-color: transparent;
}

/* Create form */
.launchpad-form__group {
  margin-bottom: 1rem;
}

.launchpad-form__group label {
  display: block;
  margin-bottom: 0.4rem;
  font-size: 0.875rem;
  font-weight: 600;
  color: var(--text);
}

.launchpad-form__group .required {
  color: #dc2626;
}

.launchpad-form__group input,
.launchpad-form__group select,
.launchpad-form__group textarea {
  width: 100%;
  max-width: 100%;
  padding: 0.65rem 1rem;
  font-size: 0.9rem;
  font-family: inherit;
  border: 1px solid var(--border);
  border-radius: 8px;
  background: #fff;
  color: var(--text);
}

.launchpad-form__group input:focus,
.launchpad-form__group select:focus,
.launchpad-form__group textarea:focus {
  outline: none;
  border-color: #0f766e;
}

.launchpad-form__readonly {
  background: #f8fafc !important;
  color: var(--text-muted);
}

.launchpad-form__group textarea {
  resize: vertical;
  min-height: 100px;
}

.launchpad-form__block {
  margin-bottom: 1.5rem;
  padding-bottom: 1.5rem;
  border-bottom: 1px solid #f1f5f9;
}

.launchpad-form__block:last-of-type {
  border-bottom: none;
}

.launchpad-form__block h3 {
  margin: 0 0 1rem;
  font-size: 1rem;
  font-weight: 600;
  color: var(--text);
}

.launchpad-form__row {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

.launchpad-form__grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));
  gap: 1rem;
}

.launchpad-form__group--span2 {
  grid-column: 1 / -1;
}

.launchpad-form__checks {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 1.5rem;
  margin-bottom: 0.5rem;
}

.launchpad-form__check {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  font-size: 0.95rem;
  cursor: pointer;
}

.launchpad-form__check input[type="checkbox"] {
  width: auto;
  margin: 0;
}

.launchpad-form__hint-inline {
  font-weight: 400;
  color: var(--text-muted);
  font-size: 0.85em;
}

.launchpad-form__grid--vesting {
  margin-top: 0.75rem;
}

.launchpad-form__vesting-value-unit {
  display: flex;
  align-items: stretch;
  gap: 0.5rem;
  flex-wrap: wrap;
}

.launchpad-form__vesting-value-unit input[type="number"] {
  flex: 1 1;
  min-width: 5rem;
}

.launchpad-form__vesting-value-unit select {
  min-width: 7.5rem;
  flex-shrink: 0;
}

.launchpad-form__file {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  flex-wrap: wrap;
}

.launchpad-form__file input[type="file"] {
  width: 0.1px;
  height: 0.1px;
  opacity: 0;
  position: absolute;
}

.launchpad-form__file-btn {
  padding: 0.5rem 1rem;
  font-size: 0.875rem;
  font-weight: 500;
  background: #f1f5f9;
  color: var(--text);
  border: 1px solid var(--border);
  border-radius: 8px;
  cursor: pointer;
  transition: background 0.2s;
}

.launchpad-form__file-btn:hover {
  background: #e2e8f0;
}

.launchpad-form__file-text {
  font-size: 0.85rem;
  color: var(--text-muted);
}

.launchpad-form__actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #f1f5f9;
}

.launchpad-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.7rem 1.25rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  border-radius: 8px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.launchpad-btn--reset {
  background: #fff;
  color: var(--text);
  border: 1px solid var(--border);
}

.launchpad-btn--reset:hover {
  background: #f8fafc;
}

.launchpad-btn--publish {
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  color: #fff;
  border: none;
  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.35);
}

.launchpad-btn--publish:hover {
  opacity: 0.95;
}

/* Tables */
.launchpad-table-wrap {
  overflow-x: auto;
}

.launchpad-table--sales-stats {
  min-width: 56rem;
}

.launchpad-table {
  width: 100%;
  border-collapse: collapse;
  font-size: 0.875rem;
}

.launchpad-table th {
  padding: 0.9rem 1rem;
  text-align: left;
  font-weight: 600;
  font-size: 0.68rem;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #64748b;
  background: #f8fafc;
  border-bottom: 2px solid var(--border);
  vertical-align: middle;
}

.launchpad-table td {
  padding: 0.9rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  color: var(--text);
  vertical-align: middle;
}

.launchpad-table tbody tr:nth-child(even) {
  background: #fafafa;
}

.launchpad-table tbody tr:hover {
  background: #f0fdfa !important;
}

.launchpad-status {
  display: inline-block;
  padding: 0.3rem 0.6rem;
  border-radius: 6px;
  font-size: 0.75rem;
  font-weight: 600;
}

.launchpad-status--upcoming {
  background: #fef3c7;
  color: #92400e;
}

.launchpad-status--live,
.launchpad-status--pending {
  background: #dcfce7;
  color: #166534;
}

.launchpad-status--ended {
  background: #f1f5f9;
  color: #64748b;
}

.launchpad-status--cancelled {
  background: #fef2f2;
  color: #b91c1c;
}

/* Action buttons in Launchpad List */
.launchpad-action-btns {
  display: inline-flex;
  flex-wrap: nowrap;
  align-items: center;
  gap: 6px;
  justify-content: flex-start;
}

.launchpad-action-btns .btn {
  padding: 0.35rem 0.65rem;
  font-size: 0.8rem;
  font-weight: 600;
  font-family: inherit;
  border: none;
  border-radius: 6px;
  cursor: pointer;
  transition: opacity 0.2s;
}

.launchpad-action-btns .btn:hover {
  opacity: 0.9;
}

/* Keep action column on one line; table scrolls horizontally if needed */
.launchpad-table tbody td:last-child {
  white-space: nowrap;
  width: 1%;
}

.launchpad-action-btns .btn-sm.btn-success {
  background: #16a34a;
  color: #fff;
}

.launchpad-action-btns .btn-sm.btn-warning {
  background: #ca8a04;
  color: #fff;
}

.launchpad-action-btns .btn-sm.btn-danger {
  background: #dc2626;
  color: #fff;
}

.launchpad-action-status {
  font-weight: 700;
}

.launchpad-action-status--ended {
  color: #ea580c;
}

.launchpad-action-status--cancelled {
  color: #dc2626;
}

@media (max-width: 992px) {
  .launchpad-cards {
    grid-template-columns: repeat(2, 1fr);
  }

  .launchpad-form__row {
    grid-template-columns: 1fr;
  }
}

/* Messages */
.launchpad-message {
  margin-bottom: 1rem;
  padding: 0.85rem 1rem;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 0.5rem;
}

.launchpad-message--success {
  background: #dcfce7;
  color: #166534;
  border: 1px solid #86efac;
}

.launchpad-message--error {
  background: #fef2f2;
  color: #b91c1c;
  border: 1px solid #fecaca;
}

.launchpad-message__close {
  background: none;
  border: none;
  font-size: 1.25rem;
  cursor: pointer;
  opacity: 0.7;
  padding: 0 0.25rem;
}

.launchpad-message__close:hover {
  opacity: 1;
}

/* Hint text */
.launchpad-section__hint {
  margin: -0.5rem 0 1rem;
  font-size: 0.875rem;
  color: var(--text-muted);
}

.launchpad-section__hint--warn {
  padding: 0.65rem 0.85rem;
  border-radius: 8px;
  background: #fffbeb;
  border: 1px solid #fde68a;
  color: #92400e;
}

/* Form validation */
.launchpad-form__error {
  border-color: #dc2626 !important;
}

.launchpad-form__err-text {
  display: block;
  font-size: 0.8rem;
  color: #dc2626;
  margin-top: 0.35rem;
}

.launchpad-form__char-count {
  display: block;
  font-size: 0.8rem;
  color: var(--text-muted);
  margin-top: 0.25rem;
}

.launchpad-form__hint {
  display: block;
  font-size: 0.8rem;
  color: var(--text-muted);
  margin-top: 0.35rem;
}

/* Loading */
.launchpad-loading {
  padding: 3rem;
  text-align: center;
  color: var(--text-muted);
}

.launchpad-loading i {
  margin-right: 0.5rem;
}

/* Table empty state */
.launchpad-table__empty {
  text-align: center;
  color: var(--text-muted);
  padding: 2rem !important;
}

/* Pagination */
.launchpad-pagination {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1rem;
  border-top: 1px solid #f1f5f9;
}

.launchpad-pagination button {
  padding: 0.5rem 1rem;
  font-size: 0.9rem;
  font-weight: 600;
  font-family: inherit;
  background: #f8fafc;
  border: 1px solid var(--border);
  border-radius: 8px;
  cursor: pointer;
}

.launchpad-pagination button:hover:not(:disabled) {
  background: #0f766e;
  color: #fff;
  border-color: #0f766e;
}

.launchpad-pagination button:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

/* Edit button */
/* Fund status (update-launchpad-fund-status) */
.launchpad-fund-status-cell {
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  gap: 0.45rem 0.5rem;
  min-width: 0;
  max-width: 220px;
}

.launchpad-fund-status-badge {
  display: inline-block;
  font-size: 0.72rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  padding: 0.2rem 0.45rem;
  border-radius: 4px;
}

.launchpad-fund-status-badge--filled {
  background: #dcfce7;
  color: #166534;
}

.launchpad-fund-status-badge--failed {
  background: #fef2f2;
  color: #b91c1c;
}

.launchpad-fund-status-badge--cancelled {
  background: #f1f5f9;
  color: #475569;
}

.launchpad-fund-status-select {
  flex: 1 1 auto;
  min-width: 118px;
  max-width: 150px;
  padding: 0.35rem 0.5rem;
  font-size: 0.75rem;
  font-family: inherit;
  border: 1px solid #e2e8f0;
  border-radius: 6px;
  background: #fff;
  color: var(--text, #1e293b);
  cursor: pointer;
}

.launchpad-fund-status-select:disabled {
  opacity: 0.65;
  cursor: not-allowed;
}

.launchpad-fund-status-select:focus {
  outline: none;
  border-color: #0f766e;
}

.launchpad-action-btns .btn-sm.btn-info {
  background: #0d9488;
  color: #fff;
}

/* Confirmation Modal */
.launchpad-confirm-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1001;
  padding: 1rem;
}

.launchpad-confirm-modal {
  background: #fff;
  border-radius: 12px;
  padding: 1.5rem;
  max-width: 420px;
  width: 100%;
  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);
}

.launchpad-confirm-title {
  margin: 0 0 0.75rem;
  font-size: 1.15rem;
  font-weight: 700;
  color: var(--text);
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.launchpad-confirm-title i {
  color: #f59e0b;
}

.launchpad-confirm-text {
  margin: 0 0 1.25rem;
  font-size: 0.9rem;
  color: var(--text-muted);
  line-height: 1.5;
}

.launchpad-confirm-actions {
  display: flex;
  justify-content: flex-end;
  gap: 0.75rem;
}

/* Edit Modal */
.launchpad-modal-overlay {
  position: fixed;
  inset: 0;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  align-items: center;
  justify-content: center;
  z-index: 1000;
  padding: 1rem;
}

.launchpad-modal {
  background: #fff;
  border-radius: 12px;
  max-width: 640px;
  width: 100%;
  max-height: 90vh;
  overflow-y: auto;
  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);
}

.launchpad-modal--edit {
  max-width: 760px;
}

.launchpad-modal--tx {
  max-width: 920px;
  width: 100%;
}

.launchpad-tx-modal__subtitle {
  display: block;
  margin-top: 0.35rem;
  font-size: 0.85rem;
  font-weight: 500;
  color: var(--text-muted);
}

.launchpad-tx-modal__body {
  padding-top: 0.5rem;
}

.launchpad-tx-modal__loading {
  padding: 2rem 1rem;
  text-align: center;
}

.launchpad-tx-modal__table-wrap {
  max-height: min(60vh, 520px);
  overflow: auto;
}

.launchpad-tx-table .launchpad-status--success {
  color: #0f766e;
  background: #ecfdf5;
  border-color: #a7f3d0;
}

.launchpad-modal__header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 1.25rem 1.5rem;
  border-bottom: 1px solid var(--border);
}

.launchpad-modal__header h3 {
  margin: 0;
  font-size: 1.15rem;
  font-weight: 700;
}

.launchpad-modal__close {
  background: none;
  border: none;
  font-size: 1.5rem;
  cursor: pointer;
  color: var(--text-muted);
  padding: 0 0.25rem;
  line-height: 1;
}

.launchpad-modal__close:hover {
  color: var(--text);
}

.launchpad-modal__body {
  padding: 1.5rem;
}

.launchpad-modal__body .launchpad-form__group {
  margin-bottom: 1rem;
}

.launchpad-modal__body .launchpad-form__row,
.launchpad-modal__body .launchpad-form__grid {
  margin-bottom: 1rem;
}

.launchpad-modal__actions {
  display: flex;
  gap: 1rem;
  justify-content: flex-end;
  margin-top: 1.5rem;
  padding-top: 1.5rem;
  border-top: 1px solid #f1f5f9;
}

.launchpad-form__err-block {
  margin-top: 0.5rem;
  padding: 0.75rem;
  background: #fef2f2;
  border-radius: 8px;
  font-size: 0.875rem;
  color: #b91c1c;
}

.launchpad-form__err-block span {
  display: block;
}

/* —— Launchpad details modal (premium) —— */
.launchpad-view-overlay {
  background: rgba(15, 23, 42, 0.72);
  backdrop-filter: blur(10px);
  -webkit-backdrop-filter: blur(10px);
}

.launchpad-view-modal {
  max-width: 760px;
  width: 100%;
  max-height: min(92vh, 900px);
  overflow: hidden;
  display: flex;
  flex-direction: column;
  border-radius: 20px;
  border: 1px solid rgba(255, 255, 255, 0.12);
  box-shadow:
    0 0 0 1px rgba(0, 0, 0, 0.04),
    0 25px 80px -12px rgba(15, 23, 42, 0.55),
    0 0 120px -20px rgba(20, 184, 166, 0.35);
  background: #f8fafc;
}

.launchpad-view__topbar {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 0.85rem 1.25rem;
  background: linear-gradient(180deg, #fff 0%, #f1f5f9 100%);
  border-bottom: 1px solid rgba(148, 163, 184, 0.25);
  flex-shrink: 0;
}

.launchpad-view__topbar-label {
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.14em;
  text-transform: uppercase;
  color: #64748b;
}

.launchpad-view__close {
  width: 2.25rem;
  height: 2.25rem;
  border: none;
  border-radius: 12px;
  background: #fff;
  color: #64748b;
  cursor: pointer;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
  transition: color 0.2s, background 0.2s, transform 0.15s;
}

.launchpad-view__close:hover {
  color: #0f766e;
  background: #ecfdf5;
  transform: scale(1.04);
}

.launchpad-view-modal__scroll {
  overflow-y: auto;
  flex: 1 1;
  min-height: 0;
  scrollbar-gutter: stable;
}

.launchpad-view-modal__scroll::-webkit-scrollbar {
  width: 8px;
}

.launchpad-view-modal__scroll::-webkit-scrollbar-thumb {
  background: #cbd5e1;
  border-radius: 8px;
}

.launchpad-view__loading {
  min-height: 280px;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 2rem;
}

.launchpad-view__loading-inner {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1rem;
  color: #64748b;
  font-size: 0.95rem;
  font-weight: 500;
}

.launchpad-view__loading-inner i {
  font-size: 2rem;
  color: #0f766e;
}

.launchpad-view__hero {
  position: relative;
  min-height: 168px;
  background: linear-gradient(135deg, #0f766e 0%, #0d9488 40%, #14b8a6 100%);
  background-size: cover;
  background-position: center;
}

.launchpad-view__hero--has-banner {
  background-size: cover;
  background-position: center;
}

.launchpad-view__hero-shade {
  position: absolute;
  inset: 0;
  background: linear-gradient(180deg, rgba(15, 23, 42, 0.15) 0%, rgba(15, 23, 42, 0.55) 100%);
  pointer-events: none;
}

.launchpad-view__hero-content {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-end;
  gap: 1.25rem;
  padding: 1.5rem 1.75rem 1.75rem;
}

.launchpad-view__logo-wrap {
  flex-shrink: 0;
  width: 88px;
  height: 88px;
  border-radius: 20px;
  overflow: hidden;
  border: 3px solid rgba(255, 255, 255, 0.95);
  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);
  background: #fff;
}

.launchpad-view__logo-wrap--placeholder {
  display: flex;
  align-items: center;
  justify-content: center;
  background: linear-gradient(145deg, #ecfdf5, #fff);
  color: #0f766e;
  font-size: 2rem;
}

.launchpad-view__logo-img {
  width: 100%;
  height: 100%;
  object-fit: cover;
}

.launchpad-view__hero-text {
  flex: 1 1;
  min-width: 0;
  padding-bottom: 0.15rem;
}

.launchpad-view__eyebrow {
  margin: 0 0 0.35rem;
  font-size: 0.7rem;
  font-weight: 700;
  letter-spacing: 0.2em;
  text-transform: uppercase;
  color: rgba(255, 255, 255, 0.85);
  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);
}

.launchpad-view__title {
  margin: 0 0 0.65rem;
  font-size: 1.65rem;
  font-weight: 800;
  line-height: 1.2;
  color: #fff;
  letter-spacing: -0.02em;
  text-shadow: 0 2px 16px rgba(0, 0, 0, 0.25);
}

.launchpad-view__symbol {
  font-weight: 600;
  opacity: 0.92;
  font-size: 1.1rem;
}

.launchpad-view__meta-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  align-items: center;
}

.launchpad-view__status.launchpad-status {
  font-size: 0.72rem;
  padding: 0.35rem 0.75rem;
  border-radius: 999px;
  font-weight: 700;
  letter-spacing: 0.04em;
  border: 1px solid rgba(255, 255, 255, 0.35);
  background: rgba(255, 255, 255, 0.18);
  color: #fff;
}

.launchpad-view__chip {
  font-size: 0.72rem;
  font-weight: 600;
  padding: 0.3rem 0.65rem;
  border-radius: 999px;
  background: rgba(255, 255, 255, 0.2);
  color: #fff;
  border: 1px solid rgba(255, 255, 255, 0.25);
}

.launchpad-view__chip--accent {
  background: rgba(255, 255, 255, 0.95);
  color: #0f766e;
  border-color: transparent;
}

.launchpad-view__chip--live {
  background: rgba(16, 185, 129, 0.35);
  border-color: rgba(167, 243, 208, 0.5);
}

.launchpad-view__chip--live i {
  font-size: 0.55rem;
  margin-right: 0.35rem;
  opacity: 0.95;
}

.launchpad-view__chip--off {
  background: rgba(15, 23, 42, 0.35);
}

.launchpad-view__body {
  padding: 1.35rem 1.5rem 1.5rem;
  background: linear-gradient(180deg, #fff 0%, #f8fafc 100%);
}

.launchpad-view__media-row {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem;
  align-items: stretch;
}

.launchpad-view__media-card {
  flex: 1 1 160px;
  min-width: 140px;
  display: flex;
  flex-direction: column;
  gap: 0.5rem;
}

.launchpad-view__media-card--wide {
  flex: 2 1 280px;
  min-width: 200px;
}

.launchpad-view__media-card-label {
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #64748b;
}

.launchpad-view__media-frame {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 14px;
  overflow: hidden;
  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.08);
}

.launchpad-view__media-frame--logo {
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0.75rem;
  max-width: 200px;
  min-height: 120px;
}

.launchpad-view__media-frame--logo img {
  max-width: 100%;
  max-height: 140px;
  width: auto;
  height: auto;
  object-fit: contain;
}

.launchpad-view__media-frame--banner {
  width: 100%;
  min-height: 140px;
  max-height: 220px;
}

.launchpad-view__media-frame--banner img {
  width: 100%;
  height: 100%;
  min-height: 140px;
  max-height: 220px;
  object-fit: cover;
  display: block;
}

.launchpad-view__stats {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.75rem;
  margin-bottom: 1.5rem;
}

@media (max-width: 640px) {
  .launchpad-view__stats {
    grid-template-columns: repeat(2, 1fr);
  }
}

.launchpad-view__stat {
  background: #fff;
  border-radius: 14px;
  padding: 1rem 1rem 0.85rem;
  border: 1px solid #e2e8f0;
  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);
  transition: box-shadow 0.2s, transform 0.2s;
}

.launchpad-view__stat:hover {
  box-shadow: 0 8px 24px rgba(15, 118, 110, 0.12);
  transform: translateY(-1px);
}

.launchpad-view__stat-label {
  display: block;
  font-size: 0.68rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.06em;
  color: #94a3b8;
  margin-bottom: 0.35rem;
}

.launchpad-view__stat-value {
  display: block;
  font-size: 1.35rem;
  font-weight: 800;
  color: #0f172a;
  letter-spacing: -0.02em;
  line-height: 1.2;
}

.launchpad-view__stat-unit {
  font-size: 0.8rem;
  font-weight: 600;
  color: #64748b;
  margin-left: 0.25rem;
}

.launchpad-view__stat-hint {
  display: block;
  font-size: 0.72rem;
  color: #94a3b8;
  margin-top: 0.25rem;
  font-weight: 500;
}

.launchpad-view__section {
  margin-bottom: 1.35rem;
}

.launchpad-view__section:last-of-type {
  margin-bottom: 0;
}

.launchpad-view__section-title {
  margin: 0 0 0.75rem;
  font-size: 0.8rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.08em;
  color: #475569;
  display: flex;
  align-items: center;
  gap: 0.5rem;
}

.launchpad-view__section-title i {
  color: #0f766e;
  font-size: 0.95rem;
  opacity: 0.9;
}

.launchpad-view__code-block {
  font-family: ui-monospace, "SF Mono", Menlo, monospace;
  font-size: 0.78rem;
  line-height: 1.5;
  padding: 0.9rem 1rem;
  background: #0f172a;
  color: #e2e8f0;
  border-radius: 12px;
  word-break: break-all;
  border: 1px solid #1e293b;
  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);
}

.launchpad-view__two-col {
  display: grid;
  grid-template-columns: 1fr 1fr;
  gap: 1rem;
}

@media (max-width: 560px) {
  .launchpad-view__two-col {
    grid-template-columns: 1fr;
  }
}

.launchpad-view__kv {
  list-style: none;
  margin: 0;
  padding: 0;
  background: #fff;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  overflow: hidden;
}

.launchpad-view__kv li {
  display: flex;
  justify-content: space-between;
  align-items: baseline;
  gap: 1rem;
  padding: 0.75rem 1rem;
  border-bottom: 1px solid #f1f5f9;
  font-size: 0.88rem;
}

.launchpad-view__kv li:last-child {
  border-bottom: none;
}

.launchpad-view__kv span {
  color: #64748b;
  font-weight: 500;
}

.launchpad-view__kv em {
  font-style: normal;
  font-weight: 700;
  color: #0f172a;
  text-align: right;
}

.launchpad-view__pills-row {
  display: flex;
  flex-wrap: wrap;
  gap: 0.5rem;
  margin-bottom: 0.75rem;
}

.launchpad-view__toggle {
  font-size: 0.78rem;
  font-weight: 600;
  padding: 0.45rem 0.85rem;
  border-radius: 999px;
  background: #f1f5f9;
  color: #64748b;
  border: 1px solid #e2e8f0;
}

.launchpad-view__toggle.is-on {
  background: linear-gradient(135deg, #ecfdf5, #d1fae5);
  color: #047857;
  border-color: #a7f3d0;
}

.launchpad-view__toggle i {
  margin-right: 0.35rem;
  opacity: 0.85;
}

.launchpad-view__vesting-cards {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 0.5rem;
}

@media (max-width: 560px) {
  .launchpad-view__vesting-cards {
    grid-template-columns: repeat(2, 1fr);
  }
}

.launchpad-view__vesting-card {
  background: #fff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  padding: 0.65rem 0.75rem;
  text-align: center;
}

.launchpad-view__vesting-card span {
  display: block;
  font-size: 0.65rem;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.05em;
  color: #94a3b8;
  margin-bottom: 0.25rem;
}

.launchpad-view__vesting-card strong {
  font-size: 1rem;
  font-weight: 800;
  color: #0f172a;
}

.launchpad-view__links {
  display: flex;
  flex-wrap: wrap;
  gap: 0.65rem;
}

.launchpad-view__link-btn {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.55rem 1.1rem;
  font-size: 0.88rem;
  font-weight: 600;
  color: #0f766e;
  background: #fff;
  border: 1px solid #99f6e4;
  border-radius: 12px;
  text-decoration: none;
  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.12);
  transition: transform 0.15s, box-shadow 0.2s, background 0.2s;
}

.launchpad-view__link-btn:hover {
  background: #ecfdf5;
  transform: translateY(-1px);
  box-shadow: 0 6px 20px rgba(15, 118, 110, 0.2);
}

.launchpad-view__section--about .launchpad-view__about {
  margin: 0;
  font-size: 0.92rem;
  line-height: 1.65;
  color: #334155;
  padding: 1rem 1.15rem;
  background: #fff;
  border-radius: 14px;
  border: 1px solid #e2e8f0;
  white-space: pre-wrap;
}

.launchpad-view__footer-meta {
  display: flex;
  flex-wrap: wrap;
  gap: 1rem 1.5rem;
  margin-top: 0.5rem;
  padding-top: 1.25rem;
  border-top: 1px dashed #cbd5e1;
  font-size: 0.78rem;
  color: #94a3b8;
  font-weight: 500;
}

.launchpad-view__footer-meta i {
  margin-right: 0.35rem;
  color: #0f766e;
  opacity: 0.8;
}

.launchpad-view__muted {
  color: #94a3b8;
  font-size: 0.88rem;
}

.launchpad-view__empty {
  color: #64748b;
  margin: 0;
  padding: 2.5rem 1.5rem;
  text-align: center;
  font-size: 0.95rem;
}

.launchpad-view__actions {
  flex-shrink: 0;
  padding: 1rem 1.5rem 1.25rem;
  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);
  border-top: 1px solid #e2e8f0;
  display: flex;
  justify-content: flex-end;
}

.launchpad-view__btn-close {
  padding: 0.65rem 1.75rem;
  font-size: 0.9rem;
  font-weight: 700;
  font-family: inherit;
  color: #fff;
  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);
  border: none;
  border-radius: 12px;
  cursor: pointer;
  box-shadow: 0 4px 14px rgba(15, 118, 110, 0.35);
  transition: transform 0.15s, box-shadow 0.2s, opacity 0.2s;
}

.launchpad-view__btn-close:hover {
  transform: translateY(-1px);
  box-shadow: 0 8px 24px rgba(15, 118, 110, 0.45);
}

.launchpad-view__btn-close:active {
  transform: translateY(0);
}

@media (max-width: 576px) {
  .launchpad-cards {
    grid-template-columns: 1fr;
  }

  .launchpad-form__grid {
    grid-template-columns: 1fr;
  }

  .launchpad-view-modal {
    max-height: 100dvh;
    border-radius: 0;
    max-width: 100%;
  }

  .launchpad-view__hero-content {
    flex-direction: column;
    align-items: flex-start;
    padding: 1.2rem 1.2rem 1.5rem;
  }

  .launchpad-view__title {
    font-size: 1.35rem;
  }

  .launchpad-view__logo-wrap {
    width: 72px;
    height: 72px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/Dashboard/Exchange/LaunchpadManagementPage.css"],"names":[],"mappings":"AAAA,yBAAyB;AACzB;EACE,oBAAoB;AACtB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,SAAS;EACT,qBAAqB;AACvB;;AAEA;EACE,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,yCAAyC;AAC3C;;AAEA;EACE,iBAAiB;EACjB,wBAAwB;AAC1B;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,YAAY;EACZ,qBAAqB;EACrB,eAAe;AACjB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,gBAAgB;EAChB,+BAA+B;EAC/B,mBAAmB;EACnB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,+BAA+B;EAC/B,yCAAyC;EACzC,gBAAgB;AAClB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA,uDAAuD;AACvD;EACE,aAAa;EACb,WAAW;EACX,sBAAsB;EACtB,eAAe;AACjB;;AAEA;EACE,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,wBAAwB;EACxB,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,6DAA6D;EAC7D,yBAAyB;AAC3B;;AAEA,gBAAgB;AAChB;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,qBAAqB;EACrB,mBAAmB;EACnB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,cAAc;AAChB;;AAEA;;;EAGE,WAAW;EACX,eAAe;EACf,qBAAqB;EACrB,iBAAiB;EACjB,oBAAoB;EACpB,+BAA+B;EAC/B,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;;;EAGE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,8BAA8B;EAC9B,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,gCAAgC;AAClC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,kBAAkB;AACpB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE,aAAa;EACb,4DAA4D;EAC5D,SAAS;AACX;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,qBAAqB;AACvB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,SAAS;AACX;;AAEA;EACE,gBAAgB;EAChB,wBAAwB;EACxB,iBAAiB;AACnB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,oBAAoB;EACpB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAO;EACP,eAAe;AACjB;;AAEA;EACE,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,YAAY;EACZ,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,aAAa;EACb,UAAU;EACV,kBAAkB;AACpB;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;EACf,2BAA2B;AAC7B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,gBAAgB;EAChB,kBAAkB;EAClB,+BAA+B;AACjC;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,WAAW;EACX,YAAY;EACZ,6CAA6C;AAC/C;;AAEA;EACE,aAAa;AACf;;AAEA,WAAW;AACX;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,oBAAoB;EACpB,gBAAgB;EAChB,gBAAgB;EAChB,kBAAkB;EAClB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,mBAAmB;EACnB,sCAAsC;EACtC,sBAAsB;AACxB;;AAEA;EACE,oBAAoB;EACpB,gCAAgC;EAChC,kBAAkB;EAClB,sBAAsB;AACxB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,8BAA8B;AAChC;;AAEA;EACE,qBAAqB;EACrB,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;;EAEE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,qCAAqC;AACrC;EACE,oBAAoB;EACpB,iBAAiB;EACjB,mBAAmB;EACnB,QAAQ;EACR,2BAA2B;AAC7B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,wBAAwB;AAC1B;;AAEA;EACE,YAAY;AACd;;AAEA,yEAAyE;AACzE;EACE,mBAAmB;EACnB,SAAS;AACX;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;AACF;;AAEA,aAAa;AACb;EACE,mBAAmB;EACnB,qBAAqB;EACrB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,WAAW;AACb;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,kBAAkB;EAClB,eAAe;EACf,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,UAAU;AACZ;;AAEA,cAAc;AACd;EACE,sBAAsB;EACtB,mBAAmB;EACnB,wBAAwB;AAC1B;;AAEA;EACE,wBAAwB;EACxB,kBAAkB;EAClB,mBAAmB;EACnB,yBAAyB;EACzB,cAAc;AAChB;;AAEA,oBAAoB;AACpB;EACE,gCAAgC;AAClC;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,cAAc;EACd,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,iBAAiB;EACjB,wBAAwB;EACxB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,kBAAkB;EAClB,wBAAwB;AAC1B;;AAEA;EACE,oBAAoB;AACtB;;AAEA,sBAAsB;AACtB;EACE,kBAAkB;EAClB,wBAAwB;EACxB,wBAAwB;AAC1B;;AAEA,eAAe;AACf;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,SAAS;EACT,aAAa;EACb,6BAA6B;AAC/B;;AAEA;EACE,oBAAoB;EACpB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,+BAA+B;EAC/B,kBAAkB;EAClB,eAAe;AACjB;;AAEA;EACE,mBAAmB;EACnB,WAAW;EACX,qBAAqB;AACvB;;AAEA;EACE,YAAY;EACZ,mBAAmB;AACrB;;AAEA,gBAAgB;AAChB,+CAA+C;AAC/C;EACE,aAAa;EACb,mBAAmB;EACnB,eAAe;EACf,mBAAmB;EACnB,mBAAmB;EACnB,YAAY;EACZ,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,gBAAgB;EAChB,gBAAgB;EAChB,uBAAuB;EACvB,kBAAkB;EAClB,oBAAoB;EACpB,yBAAyB;EACzB,kBAAkB;EAClB,gBAAgB;EAChB,2BAA2B;EAC3B,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,qBAAqB;AACvB;;AAEA;EACE,mBAAmB;EACnB,WAAW;AACb;;AAEA,uBAAuB;AACvB;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;EAChB,WAAW;EACX,0CAA0C;AAC5C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,wBAAwB;EACxB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,yBAAyB;EACzB,YAAY;AACd;;AAEA,eAAe;AACf;EACE,eAAe;EACf,QAAQ;EACR,8BAA8B;EAC9B,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;EACb,aAAa;AACf;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,gBAAgB;EAChB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,0CAA0C;AAC5C;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;AAC1B;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,4BAA4B;EAC5B,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,uBAAuB;EACvB,sCAAsC;AACxC;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,gBAAgB;EAChB,YAAY;EACZ,iBAAiB;EACjB,eAAe;EACf,wBAAwB;EACxB,kBAAkB;EAClB,cAAc;AAChB;;AAEA;EACE,kBAAkB;AACpB;;AAEA;EACE,eAAe;AACjB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;;EAEE,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,SAAS;EACT,yBAAyB;EACzB,kBAAkB;EAClB,mBAAmB;EACnB,6BAA6B;AAC/B;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,mBAAmB;EACnB,kBAAkB;EAClB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,cAAc;AAChB;;AAEA,4CAA4C;AAC5C;EACE,kCAAkC;EAClC,2BAA2B;EAC3B,mCAAmC;AACrC;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,4BAA4B;EAC5B,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,2CAA2C;EAC3C;;;4CAG0C;EAC1C,mBAAmB;AACrB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,8BAA8B;EAC9B,wBAAwB;EACxB,0DAA0D;EAC1D,kDAAkD;EAClD,cAAc;AAChB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,sBAAsB;EACtB,yBAAyB;EACzB,cAAc;AAChB;;AAEA;EACE,cAAc;EACd,eAAe;EACf,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,cAAc;EACd,eAAe;EACf,oBAAoB;EACpB,mBAAmB;EACnB,uBAAuB;EACvB,yCAAyC;EACzC,wDAAwD;AAC1D;;AAEA;EACE,cAAc;EACd,mBAAmB;EACnB,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;EAChB,SAAO;EACP,aAAa;EACb,wBAAwB;AAC1B;;AAEA;EACE,UAAU;AACZ;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,iBAAiB;EACjB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,SAAS;EACT,cAAc;EACd,kBAAkB;EAClB,gBAAgB;AAClB;;AAEA;EACE,eAAe;EACf,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,iBAAiB;EACjB,0EAA0E;EAC1E,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,sBAAsB;EACtB,2BAA2B;AAC7B;;AAEA;EACE,kBAAkB;EAClB,QAAQ;EACR,2FAA2F;EAC3F,oBAAoB;AACtB;;AAEA;EACE,kBAAkB;EAClB,UAAU;EACV,aAAa;EACb,qBAAqB;EACrB,YAAY;EACZ,+BAA+B;AACjC;;AAEA;EACE,cAAc;EACd,WAAW;EACX,YAAY;EACZ,mBAAmB;EACnB,gBAAgB;EAChB,2CAA2C;EAC3C,2CAA2C;EAC3C,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kDAAkD;EAClD,cAAc;EACd,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;AACnB;;AAEA;EACE,SAAO;EACP,YAAY;EACZ,uBAAuB;AACzB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,qBAAqB;EACrB,yBAAyB;EACzB,gCAAgC;EAChC,yCAAyC;AAC3C;;AAEA;EACE,mBAAmB;EACnB,kBAAkB;EAClB,gBAAgB;EAChB,gBAAgB;EAChB,WAAW;EACX,uBAAuB;EACvB,2CAA2C;AAC7C;;AAEA;EACE,gBAAgB;EAChB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,mBAAmB;AACrB;;AAEA;EACE,kBAAkB;EAClB,wBAAwB;EACxB,oBAAoB;EACpB,gBAAgB;EAChB,sBAAsB;EACtB,2CAA2C;EAC3C,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,uBAAuB;EACvB,oBAAoB;EACpB,oCAAoC;EACpC,WAAW;EACX,2CAA2C;AAC7C;;AAEA;EACE,qCAAqC;EACrC,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,oCAAoC;EACpC,sCAAsC;AACxC;;AAEA;EACE,kBAAkB;EAClB,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,kCAAkC;AACpC;;AAEA;EACE,8BAA8B;EAC9B,0DAA0D;AAC5D;;AAEA;EACE,aAAa;EACb,eAAe;EACf,SAAS;EACT,oBAAoB;AACtB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,aAAa;EACb,sBAAsB;EACtB,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;AAChB;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,6CAA6C;AAC/C;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,gBAAgB;EAChB,gBAAgB;EAChB,iBAAiB;AACnB;;AAEA;EACE,eAAe;EACf,iBAAiB;EACjB,WAAW;EACX,YAAY;EACZ,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,iBAAiB;EACjB,iBAAiB;AACnB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,iBAAiB;EACjB,iBAAiB;EACjB,iBAAiB;EACjB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,YAAY;EACZ,qBAAqB;AACvB;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,gBAAgB;EAChB,mBAAmB;EACnB,0BAA0B;EAC1B,yBAAyB;EACzB,4CAA4C;EAC5C,2CAA2C;AAC7C;;AAEA;EACE,+CAA+C;EAC/C,2BAA2B;AAC7B;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,uBAAuB;EACvB,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,gBAAgB;EAChB,cAAc;EACd,oBAAoB;AACtB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,cAAc;EACd,mBAAmB;EACnB,gBAAgB;AAClB;;AAEA;EACE,sBAAsB;AACxB;;AAEA;EACE,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,iBAAiB;EACjB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,aAAa;EACb,mBAAmB;EACnB,WAAW;AACb;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,YAAY;AACd;;AAEA;EACE,sDAAsD;EACtD,kBAAkB;EAClB,gBAAgB;EAChB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,mBAAmB;EACnB,qBAAqB;EACrB,yBAAyB;EACzB,mDAAmD;AACrD;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,SAAS;AACX;;AAEA;EACE;IACE,0BAA0B;EAC5B;AACF;;AAEA;EACE,gBAAgB;EAChB,SAAS;EACT,UAAU;EACV,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,gBAAgB;AAClB;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,qBAAqB;EACrB,SAAS;EACT,qBAAqB;EACrB,gCAAgC;EAChC,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,WAAW;EACX,sBAAsB;AACxB;;AAEA;EACE,kBAAkB;EAClB,gBAAgB;EAChB,wBAAwB;EACxB,oBAAoB;EACpB,mBAAmB;EACnB,cAAc;EACd,yBAAyB;AAC3B;;AAEA;EACE,qDAAqD;EACrD,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,qBAAqB;EACrB,aAAa;AACf;;AAEA;EACE,aAAa;EACb,qCAAqC;EACrC,WAAW;AACb;;AAEA;EACE;IACE,qCAAqC;EACvC;AACF;;AAEA;EACE,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,wBAAwB;EACxB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,kBAAkB;EAClB,gBAAgB;EAChB,yBAAyB;EACzB,sBAAsB;EACtB,cAAc;EACd,sBAAsB;AACxB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,cAAc;AAChB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,YAAY;AACd;;AAEA;EACE,oBAAoB;EACpB,mBAAmB;EACnB,WAAW;EACX,uBAAuB;EACvB,kBAAkB;EAClB,gBAAgB;EAChB,cAAc;EACd,gBAAgB;EAChB,yBAAyB;EACzB,mBAAmB;EACnB,qBAAqB;EACrB,8CAA8C;EAC9C,6DAA6D;AAC/D;;AAEA;EACE,mBAAmB;EACnB,2BAA2B;EAC3B,8CAA8C;AAChD;;AAEA;EACE,SAAS;EACT,kBAAkB;EAClB,iBAAiB;EACjB,cAAc;EACd,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;EACnB,yBAAyB;EACzB,qBAAqB;AACvB;;AAEA;EACE,aAAa;EACb,eAAe;EACf,gBAAgB;EAChB,kBAAkB;EAClB,oBAAoB;EACpB,8BAA8B;EAC9B,kBAAkB;EAClB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,qBAAqB;EACrB,cAAc;EACd,YAAY;AACd;;AAEA;EACE,cAAc;EACd,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,SAAS;EACT,sBAAsB;EACtB,kBAAkB;EAClB,kBAAkB;AACpB;;AAEA;EACE,cAAc;EACd,4BAA4B;EAC5B,0DAA0D;EAC1D,6BAA6B;EAC7B,aAAa;EACb,yBAAyB;AAC3B;;AAEA;EACE,wBAAwB;EACxB,iBAAiB;EACjB,gBAAgB;EAChB,oBAAoB;EACpB,WAAW;EACX,6DAA6D;EAC7D,YAAY;EACZ,mBAAmB;EACnB,eAAe;EACf,+CAA+C;EAC/C,0DAA0D;AAC5D;;AAEA;EACE,2BAA2B;EAC3B,+CAA+C;AACjD;;AAEA;EACE,wBAAwB;AAC1B;;AAEA;EACE;IACE,0BAA0B;EAC5B;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,kBAAkB;IAClB,gBAAgB;IAChB,eAAe;EACjB;;EAEA;IACE,sBAAsB;IACtB,uBAAuB;IACvB,6BAA6B;EAC/B;;EAEA;IACE,kBAAkB;EACpB;;EAEA;IACE,WAAW;IACX,YAAY;EACd;AACF","sourcesContent":["/* Launchpad Management */\n.launchpad-page .dashboard-body {\n  padding-bottom: 2rem;\n}\n\n.launchpad-cards {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 1rem;\n  margin-bottom: 1.5rem;\n}\n\n.launchpad-card {\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 12px;\n  padding: 1.25rem;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 0.5rem;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.06);\n}\n\n.launchpad-card i {\n  font-size: 1.5rem;\n  color: var(--text-muted);\n}\n\n.launchpad-card__value {\n  font-size: 1.5rem;\n  font-weight: 700;\n  color: #0f766e;\n}\n\n.launchpad-card__label {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.launchpad-tabs {\n  display: flex;\n  gap: 0.25rem;\n  margin-bottom: 1.5rem;\n  flex-wrap: wrap;\n}\n\n.launchpad-tab {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.85rem 1.5rem;\n  font-size: 0.95rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: var(--text-muted);\n  background: #fff;\n  border: 1px solid var(--border);\n  border-radius: 10px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.launchpad-tab:hover {\n  color: #0f766e;\n  border-color: #0f766e;\n  background: #f0fdfa;\n}\n\n.launchpad-tab--active {\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  border-color: transparent;\n}\n\n.launchpad-content {\n  background: #fff;\n  border-radius: 12px;\n  border: 1px solid var(--border);\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);\n  overflow: hidden;\n}\n\n.launchpad-section {\n  padding: 1.5rem;\n}\n\n.launchpad-section__title {\n  margin: 0 0 1.25rem;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.launchpad-section__title i {\n  color: #0f766e;\n}\n\n/* Launchpad List sub-tabs (Upcoming, Pending, Ended) */\n.launchpad-list-tabs {\n  display: flex;\n  gap: 0.5rem;\n  margin-bottom: 1.25rem;\n  flex-wrap: wrap;\n}\n\n.launchpad-list-tab {\n  padding: 0.6rem 1.25rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  color: var(--text-muted);\n  background: #f8fafc;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: all 0.2s;\n}\n\n.launchpad-list-tab:hover {\n  color: #0f766e;\n  border-color: #0f766e;\n  background: #f0fdfa;\n}\n\n.launchpad-list-tab--active {\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  border-color: transparent;\n}\n\n/* Create form */\n.launchpad-form__group {\n  margin-bottom: 1rem;\n}\n\n.launchpad-form__group label {\n  display: block;\n  margin-bottom: 0.4rem;\n  font-size: 0.875rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.launchpad-form__group .required {\n  color: #dc2626;\n}\n\n.launchpad-form__group input,\n.launchpad-form__group select,\n.launchpad-form__group textarea {\n  width: 100%;\n  max-width: 100%;\n  padding: 0.65rem 1rem;\n  font-size: 0.9rem;\n  font-family: inherit;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  background: #fff;\n  color: var(--text);\n}\n\n.launchpad-form__group input:focus,\n.launchpad-form__group select:focus,\n.launchpad-form__group textarea:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.launchpad-form__readonly {\n  background: #f8fafc !important;\n  color: var(--text-muted);\n}\n\n.launchpad-form__group textarea {\n  resize: vertical;\n  min-height: 100px;\n}\n\n.launchpad-form__block {\n  margin-bottom: 1.5rem;\n  padding-bottom: 1.5rem;\n  border-bottom: 1px solid #f1f5f9;\n}\n\n.launchpad-form__block:last-of-type {\n  border-bottom: none;\n}\n\n.launchpad-form__block h3 {\n  margin: 0 0 1rem;\n  font-size: 1rem;\n  font-weight: 600;\n  color: var(--text);\n}\n\n.launchpad-form__row {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n.launchpad-form__grid {\n  display: grid;\n  grid-template-columns: repeat(auto-fill, minmax(200px, 1fr));\n  gap: 1rem;\n}\n\n.launchpad-form__group--span2 {\n  grid-column: 1 / -1;\n}\n\n.launchpad-form__checks {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem 1.5rem;\n  margin-bottom: 0.5rem;\n}\n\n.launchpad-form__check {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  font-size: 0.95rem;\n  cursor: pointer;\n}\n\n.launchpad-form__check input[type=\"checkbox\"] {\n  width: auto;\n  margin: 0;\n}\n\n.launchpad-form__hint-inline {\n  font-weight: 400;\n  color: var(--text-muted);\n  font-size: 0.85em;\n}\n\n.launchpad-form__grid--vesting {\n  margin-top: 0.75rem;\n}\n\n.launchpad-form__vesting-value-unit {\n  display: flex;\n  align-items: stretch;\n  gap: 0.5rem;\n  flex-wrap: wrap;\n}\n\n.launchpad-form__vesting-value-unit input[type=\"number\"] {\n  flex: 1;\n  min-width: 5rem;\n}\n\n.launchpad-form__vesting-value-unit select {\n  min-width: 7.5rem;\n  flex-shrink: 0;\n}\n\n.launchpad-form__file {\n  display: flex;\n  align-items: center;\n  gap: 0.75rem;\n  flex-wrap: wrap;\n}\n\n.launchpad-form__file input[type=\"file\"] {\n  width: 0.1px;\n  height: 0.1px;\n  opacity: 0;\n  position: absolute;\n}\n\n.launchpad-form__file-btn {\n  padding: 0.5rem 1rem;\n  font-size: 0.875rem;\n  font-weight: 500;\n  background: #f1f5f9;\n  color: var(--text);\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  cursor: pointer;\n  transition: background 0.2s;\n}\n\n.launchpad-form__file-btn:hover {\n  background: #e2e8f0;\n}\n\n.launchpad-form__file-text {\n  font-size: 0.85rem;\n  color: var(--text-muted);\n}\n\n.launchpad-form__actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #f1f5f9;\n}\n\n.launchpad-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.7rem 1.25rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  border-radius: 8px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.launchpad-btn--reset {\n  background: #fff;\n  color: var(--text);\n  border: 1px solid var(--border);\n}\n\n.launchpad-btn--reset:hover {\n  background: #f8fafc;\n}\n\n.launchpad-btn--publish {\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  color: #fff;\n  border: none;\n  box-shadow: 0 2px 6px rgba(37, 99, 235, 0.35);\n}\n\n.launchpad-btn--publish:hover {\n  opacity: 0.95;\n}\n\n/* Tables */\n.launchpad-table-wrap {\n  overflow-x: auto;\n}\n\n.launchpad-table--sales-stats {\n  min-width: 56rem;\n}\n\n.launchpad-table {\n  width: 100%;\n  border-collapse: collapse;\n  font-size: 0.875rem;\n}\n\n.launchpad-table th {\n  padding: 0.9rem 1rem;\n  text-align: left;\n  font-weight: 600;\n  font-size: 0.68rem;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #64748b;\n  background: #f8fafc;\n  border-bottom: 2px solid var(--border);\n  vertical-align: middle;\n}\n\n.launchpad-table td {\n  padding: 0.9rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  color: var(--text);\n  vertical-align: middle;\n}\n\n.launchpad-table tbody tr:nth-child(even) {\n  background: #fafafa;\n}\n\n.launchpad-table tbody tr:hover {\n  background: #f0fdfa !important;\n}\n\n.launchpad-status {\n  display: inline-block;\n  padding: 0.3rem 0.6rem;\n  border-radius: 6px;\n  font-size: 0.75rem;\n  font-weight: 600;\n}\n\n.launchpad-status--upcoming {\n  background: #fef3c7;\n  color: #92400e;\n}\n\n.launchpad-status--live,\n.launchpad-status--pending {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.launchpad-status--ended {\n  background: #f1f5f9;\n  color: #64748b;\n}\n\n.launchpad-status--cancelled {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n/* Action buttons in Launchpad List */\n.launchpad-action-btns {\n  display: inline-flex;\n  flex-wrap: nowrap;\n  align-items: center;\n  gap: 6px;\n  justify-content: flex-start;\n}\n\n.launchpad-action-btns .btn {\n  padding: 0.35rem 0.65rem;\n  font-size: 0.8rem;\n  font-weight: 600;\n  font-family: inherit;\n  border: none;\n  border-radius: 6px;\n  cursor: pointer;\n  transition: opacity 0.2s;\n}\n\n.launchpad-action-btns .btn:hover {\n  opacity: 0.9;\n}\n\n/* Keep action column on one line; table scrolls horizontally if needed */\n.launchpad-table tbody td:last-child {\n  white-space: nowrap;\n  width: 1%;\n}\n\n.launchpad-action-btns .btn-sm.btn-success {\n  background: #16a34a;\n  color: #fff;\n}\n\n.launchpad-action-btns .btn-sm.btn-warning {\n  background: #ca8a04;\n  color: #fff;\n}\n\n.launchpad-action-btns .btn-sm.btn-danger {\n  background: #dc2626;\n  color: #fff;\n}\n\n.launchpad-action-status {\n  font-weight: 700;\n}\n\n.launchpad-action-status--ended {\n  color: #ea580c;\n}\n\n.launchpad-action-status--cancelled {\n  color: #dc2626;\n}\n\n@media (max-width: 992px) {\n  .launchpad-cards {\n    grid-template-columns: repeat(2, 1fr);\n  }\n\n  .launchpad-form__row {\n    grid-template-columns: 1fr;\n  }\n}\n\n/* Messages */\n.launchpad-message {\n  margin-bottom: 1rem;\n  padding: 0.85rem 1rem;\n  border-radius: 8px;\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  gap: 0.5rem;\n}\n\n.launchpad-message--success {\n  background: #dcfce7;\n  color: #166534;\n  border: 1px solid #86efac;\n}\n\n.launchpad-message--error {\n  background: #fef2f2;\n  color: #b91c1c;\n  border: 1px solid #fecaca;\n}\n\n.launchpad-message__close {\n  background: none;\n  border: none;\n  font-size: 1.25rem;\n  cursor: pointer;\n  opacity: 0.7;\n  padding: 0 0.25rem;\n}\n\n.launchpad-message__close:hover {\n  opacity: 1;\n}\n\n/* Hint text */\n.launchpad-section__hint {\n  margin: -0.5rem 0 1rem;\n  font-size: 0.875rem;\n  color: var(--text-muted);\n}\n\n.launchpad-section__hint--warn {\n  padding: 0.65rem 0.85rem;\n  border-radius: 8px;\n  background: #fffbeb;\n  border: 1px solid #fde68a;\n  color: #92400e;\n}\n\n/* Form validation */\n.launchpad-form__error {\n  border-color: #dc2626 !important;\n}\n\n.launchpad-form__err-text {\n  display: block;\n  font-size: 0.8rem;\n  color: #dc2626;\n  margin-top: 0.35rem;\n}\n\n.launchpad-form__char-count {\n  display: block;\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  margin-top: 0.25rem;\n}\n\n.launchpad-form__hint {\n  display: block;\n  font-size: 0.8rem;\n  color: var(--text-muted);\n  margin-top: 0.35rem;\n}\n\n/* Loading */\n.launchpad-loading {\n  padding: 3rem;\n  text-align: center;\n  color: var(--text-muted);\n}\n\n.launchpad-loading i {\n  margin-right: 0.5rem;\n}\n\n/* Table empty state */\n.launchpad-table__empty {\n  text-align: center;\n  color: var(--text-muted);\n  padding: 2rem !important;\n}\n\n/* Pagination */\n.launchpad-pagination {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  gap: 1rem;\n  padding: 1rem;\n  border-top: 1px solid #f1f5f9;\n}\n\n.launchpad-pagination button {\n  padding: 0.5rem 1rem;\n  font-size: 0.9rem;\n  font-weight: 600;\n  font-family: inherit;\n  background: #f8fafc;\n  border: 1px solid var(--border);\n  border-radius: 8px;\n  cursor: pointer;\n}\n\n.launchpad-pagination button:hover:not(:disabled) {\n  background: #0f766e;\n  color: #fff;\n  border-color: #0f766e;\n}\n\n.launchpad-pagination button:disabled {\n  opacity: 0.5;\n  cursor: not-allowed;\n}\n\n/* Edit button */\n/* Fund status (update-launchpad-fund-status) */\n.launchpad-fund-status-cell {\n  display: flex;\n  flex-direction: row;\n  flex-wrap: wrap;\n  align-items: center;\n  gap: 0.45rem 0.5rem;\n  min-width: 0;\n  max-width: 220px;\n}\n\n.launchpad-fund-status-badge {\n  display: inline-block;\n  font-size: 0.72rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.04em;\n  padding: 0.2rem 0.45rem;\n  border-radius: 4px;\n}\n\n.launchpad-fund-status-badge--filled {\n  background: #dcfce7;\n  color: #166534;\n}\n\n.launchpad-fund-status-badge--failed {\n  background: #fef2f2;\n  color: #b91c1c;\n}\n\n.launchpad-fund-status-badge--cancelled {\n  background: #f1f5f9;\n  color: #475569;\n}\n\n.launchpad-fund-status-select {\n  flex: 1 1 auto;\n  min-width: 118px;\n  max-width: 150px;\n  padding: 0.35rem 0.5rem;\n  font-size: 0.75rem;\n  font-family: inherit;\n  border: 1px solid #e2e8f0;\n  border-radius: 6px;\n  background: #fff;\n  color: var(--text, #1e293b);\n  cursor: pointer;\n}\n\n.launchpad-fund-status-select:disabled {\n  opacity: 0.65;\n  cursor: not-allowed;\n}\n\n.launchpad-fund-status-select:focus {\n  outline: none;\n  border-color: #0f766e;\n}\n\n.launchpad-action-btns .btn-sm.btn-info {\n  background: #0d9488;\n  color: #fff;\n}\n\n/* Confirmation Modal */\n.launchpad-confirm-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1001;\n  padding: 1rem;\n}\n\n.launchpad-confirm-modal {\n  background: #fff;\n  border-radius: 12px;\n  padding: 1.5rem;\n  max-width: 420px;\n  width: 100%;\n  box-shadow: 0 20px 40px rgba(0, 0, 0, 0.2);\n}\n\n.launchpad-confirm-title {\n  margin: 0 0 0.75rem;\n  font-size: 1.15rem;\n  font-weight: 700;\n  color: var(--text);\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.launchpad-confirm-title i {\n  color: #f59e0b;\n}\n\n.launchpad-confirm-text {\n  margin: 0 0 1.25rem;\n  font-size: 0.9rem;\n  color: var(--text-muted);\n  line-height: 1.5;\n}\n\n.launchpad-confirm-actions {\n  display: flex;\n  justify-content: flex-end;\n  gap: 0.75rem;\n}\n\n/* Edit Modal */\n.launchpad-modal-overlay {\n  position: fixed;\n  inset: 0;\n  background: rgba(0, 0, 0, 0.5);\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  z-index: 1000;\n  padding: 1rem;\n}\n\n.launchpad-modal {\n  background: #fff;\n  border-radius: 12px;\n  max-width: 640px;\n  width: 100%;\n  max-height: 90vh;\n  overflow-y: auto;\n  box-shadow: 0 20px 60px rgba(0, 0, 0, 0.2);\n}\n\n.launchpad-modal--edit {\n  max-width: 760px;\n}\n\n.launchpad-modal--tx {\n  max-width: 920px;\n  width: 100%;\n}\n\n.launchpad-tx-modal__subtitle {\n  display: block;\n  margin-top: 0.35rem;\n  font-size: 0.85rem;\n  font-weight: 500;\n  color: var(--text-muted);\n}\n\n.launchpad-tx-modal__body {\n  padding-top: 0.5rem;\n}\n\n.launchpad-tx-modal__loading {\n  padding: 2rem 1rem;\n  text-align: center;\n}\n\n.launchpad-tx-modal__table-wrap {\n  max-height: min(60vh, 520px);\n  overflow: auto;\n}\n\n.launchpad-tx-table .launchpad-status--success {\n  color: #0f766e;\n  background: #ecfdf5;\n  border-color: #a7f3d0;\n}\n\n.launchpad-modal__header {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 1.25rem 1.5rem;\n  border-bottom: 1px solid var(--border);\n}\n\n.launchpad-modal__header h3 {\n  margin: 0;\n  font-size: 1.15rem;\n  font-weight: 700;\n}\n\n.launchpad-modal__close {\n  background: none;\n  border: none;\n  font-size: 1.5rem;\n  cursor: pointer;\n  color: var(--text-muted);\n  padding: 0 0.25rem;\n  line-height: 1;\n}\n\n.launchpad-modal__close:hover {\n  color: var(--text);\n}\n\n.launchpad-modal__body {\n  padding: 1.5rem;\n}\n\n.launchpad-modal__body .launchpad-form__group {\n  margin-bottom: 1rem;\n}\n\n.launchpad-modal__body .launchpad-form__row,\n.launchpad-modal__body .launchpad-form__grid {\n  margin-bottom: 1rem;\n}\n\n.launchpad-modal__actions {\n  display: flex;\n  gap: 1rem;\n  justify-content: flex-end;\n  margin-top: 1.5rem;\n  padding-top: 1.5rem;\n  border-top: 1px solid #f1f5f9;\n}\n\n.launchpad-form__err-block {\n  margin-top: 0.5rem;\n  padding: 0.75rem;\n  background: #fef2f2;\n  border-radius: 8px;\n  font-size: 0.875rem;\n  color: #b91c1c;\n}\n\n.launchpad-form__err-block span {\n  display: block;\n}\n\n/* —— Launchpad details modal (premium) —— */\n.launchpad-view-overlay {\n  background: rgba(15, 23, 42, 0.72);\n  backdrop-filter: blur(10px);\n  -webkit-backdrop-filter: blur(10px);\n}\n\n.launchpad-view-modal {\n  max-width: 760px;\n  width: 100%;\n  max-height: min(92vh, 900px);\n  overflow: hidden;\n  display: flex;\n  flex-direction: column;\n  border-radius: 20px;\n  border: 1px solid rgba(255, 255, 255, 0.12);\n  box-shadow:\n    0 0 0 1px rgba(0, 0, 0, 0.04),\n    0 25px 80px -12px rgba(15, 23, 42, 0.55),\n    0 0 120px -20px rgba(20, 184, 166, 0.35);\n  background: #f8fafc;\n}\n\n.launchpad-view__topbar {\n  display: flex;\n  align-items: center;\n  justify-content: space-between;\n  padding: 0.85rem 1.25rem;\n  background: linear-gradient(180deg, #fff 0%, #f1f5f9 100%);\n  border-bottom: 1px solid rgba(148, 163, 184, 0.25);\n  flex-shrink: 0;\n}\n\n.launchpad-view__topbar-label {\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.14em;\n  text-transform: uppercase;\n  color: #64748b;\n}\n\n.launchpad-view__close {\n  width: 2.25rem;\n  height: 2.25rem;\n  border: none;\n  border-radius: 12px;\n  background: #fff;\n  color: #64748b;\n  cursor: pointer;\n  display: inline-flex;\n  align-items: center;\n  justify-content: center;\n  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);\n  transition: color 0.2s, background 0.2s, transform 0.15s;\n}\n\n.launchpad-view__close:hover {\n  color: #0f766e;\n  background: #ecfdf5;\n  transform: scale(1.04);\n}\n\n.launchpad-view-modal__scroll {\n  overflow-y: auto;\n  flex: 1;\n  min-height: 0;\n  scrollbar-gutter: stable;\n}\n\n.launchpad-view-modal__scroll::-webkit-scrollbar {\n  width: 8px;\n}\n\n.launchpad-view-modal__scroll::-webkit-scrollbar-thumb {\n  background: #cbd5e1;\n  border-radius: 8px;\n}\n\n.launchpad-view__loading {\n  min-height: 280px;\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 2rem;\n}\n\n.launchpad-view__loading-inner {\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  gap: 1rem;\n  color: #64748b;\n  font-size: 0.95rem;\n  font-weight: 500;\n}\n\n.launchpad-view__loading-inner i {\n  font-size: 2rem;\n  color: #0f766e;\n}\n\n.launchpad-view__hero {\n  position: relative;\n  min-height: 168px;\n  background: linear-gradient(135deg, #0f766e 0%, #0d9488 40%, #14b8a6 100%);\n  background-size: cover;\n  background-position: center;\n}\n\n.launchpad-view__hero--has-banner {\n  background-size: cover;\n  background-position: center;\n}\n\n.launchpad-view__hero-shade {\n  position: absolute;\n  inset: 0;\n  background: linear-gradient(180deg, rgba(15, 23, 42, 0.15) 0%, rgba(15, 23, 42, 0.55) 100%);\n  pointer-events: none;\n}\n\n.launchpad-view__hero-content {\n  position: relative;\n  z-index: 1;\n  display: flex;\n  align-items: flex-end;\n  gap: 1.25rem;\n  padding: 1.5rem 1.75rem 1.75rem;\n}\n\n.launchpad-view__logo-wrap {\n  flex-shrink: 0;\n  width: 88px;\n  height: 88px;\n  border-radius: 20px;\n  overflow: hidden;\n  border: 3px solid rgba(255, 255, 255, 0.95);\n  box-shadow: 0 12px 40px rgba(0, 0, 0, 0.25);\n  background: #fff;\n}\n\n.launchpad-view__logo-wrap--placeholder {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  background: linear-gradient(145deg, #ecfdf5, #fff);\n  color: #0f766e;\n  font-size: 2rem;\n}\n\n.launchpad-view__logo-img {\n  width: 100%;\n  height: 100%;\n  object-fit: cover;\n}\n\n.launchpad-view__hero-text {\n  flex: 1;\n  min-width: 0;\n  padding-bottom: 0.15rem;\n}\n\n.launchpad-view__eyebrow {\n  margin: 0 0 0.35rem;\n  font-size: 0.7rem;\n  font-weight: 700;\n  letter-spacing: 0.2em;\n  text-transform: uppercase;\n  color: rgba(255, 255, 255, 0.85);\n  text-shadow: 0 1px 2px rgba(0, 0, 0, 0.2);\n}\n\n.launchpad-view__title {\n  margin: 0 0 0.65rem;\n  font-size: 1.65rem;\n  font-weight: 800;\n  line-height: 1.2;\n  color: #fff;\n  letter-spacing: -0.02em;\n  text-shadow: 0 2px 16px rgba(0, 0, 0, 0.25);\n}\n\n.launchpad-view__symbol {\n  font-weight: 600;\n  opacity: 0.92;\n  font-size: 1.1rem;\n}\n\n.launchpad-view__meta-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  align-items: center;\n}\n\n.launchpad-view__status.launchpad-status {\n  font-size: 0.72rem;\n  padding: 0.35rem 0.75rem;\n  border-radius: 999px;\n  font-weight: 700;\n  letter-spacing: 0.04em;\n  border: 1px solid rgba(255, 255, 255, 0.35);\n  background: rgba(255, 255, 255, 0.18);\n  color: #fff;\n}\n\n.launchpad-view__chip {\n  font-size: 0.72rem;\n  font-weight: 600;\n  padding: 0.3rem 0.65rem;\n  border-radius: 999px;\n  background: rgba(255, 255, 255, 0.2);\n  color: #fff;\n  border: 1px solid rgba(255, 255, 255, 0.25);\n}\n\n.launchpad-view__chip--accent {\n  background: rgba(255, 255, 255, 0.95);\n  color: #0f766e;\n  border-color: transparent;\n}\n\n.launchpad-view__chip--live {\n  background: rgba(16, 185, 129, 0.35);\n  border-color: rgba(167, 243, 208, 0.5);\n}\n\n.launchpad-view__chip--live i {\n  font-size: 0.55rem;\n  margin-right: 0.35rem;\n  opacity: 0.95;\n}\n\n.launchpad-view__chip--off {\n  background: rgba(15, 23, 42, 0.35);\n}\n\n.launchpad-view__body {\n  padding: 1.35rem 1.5rem 1.5rem;\n  background: linear-gradient(180deg, #fff 0%, #f8fafc 100%);\n}\n\n.launchpad-view__media-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem;\n  align-items: stretch;\n}\n\n.launchpad-view__media-card {\n  flex: 1 1 160px;\n  min-width: 140px;\n  display: flex;\n  flex-direction: column;\n  gap: 0.5rem;\n}\n\n.launchpad-view__media-card--wide {\n  flex: 2 1 280px;\n  min-width: 200px;\n}\n\n.launchpad-view__media-card-label {\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #64748b;\n}\n\n.launchpad-view__media-frame {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 14px;\n  overflow: hidden;\n  box-shadow: 0 4px 20px rgba(15, 23, 42, 0.08);\n}\n\n.launchpad-view__media-frame--logo {\n  display: flex;\n  align-items: center;\n  justify-content: center;\n  padding: 0.75rem;\n  max-width: 200px;\n  min-height: 120px;\n}\n\n.launchpad-view__media-frame--logo img {\n  max-width: 100%;\n  max-height: 140px;\n  width: auto;\n  height: auto;\n  object-fit: contain;\n}\n\n.launchpad-view__media-frame--banner {\n  width: 100%;\n  min-height: 140px;\n  max-height: 220px;\n}\n\n.launchpad-view__media-frame--banner img {\n  width: 100%;\n  height: 100%;\n  min-height: 140px;\n  max-height: 220px;\n  object-fit: cover;\n  display: block;\n}\n\n.launchpad-view__stats {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 0.75rem;\n  margin-bottom: 1.5rem;\n}\n\n@media (max-width: 640px) {\n  .launchpad-view__stats {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.launchpad-view__stat {\n  background: #fff;\n  border-radius: 14px;\n  padding: 1rem 1rem 0.85rem;\n  border: 1px solid #e2e8f0;\n  box-shadow: 0 1px 3px rgba(15, 23, 42, 0.06);\n  transition: box-shadow 0.2s, transform 0.2s;\n}\n\n.launchpad-view__stat:hover {\n  box-shadow: 0 8px 24px rgba(15, 118, 110, 0.12);\n  transform: translateY(-1px);\n}\n\n.launchpad-view__stat-label {\n  display: block;\n  font-size: 0.68rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.06em;\n  color: #94a3b8;\n  margin-bottom: 0.35rem;\n}\n\n.launchpad-view__stat-value {\n  display: block;\n  font-size: 1.35rem;\n  font-weight: 800;\n  color: #0f172a;\n  letter-spacing: -0.02em;\n  line-height: 1.2;\n}\n\n.launchpad-view__stat-unit {\n  font-size: 0.8rem;\n  font-weight: 600;\n  color: #64748b;\n  margin-left: 0.25rem;\n}\n\n.launchpad-view__stat-hint {\n  display: block;\n  font-size: 0.72rem;\n  color: #94a3b8;\n  margin-top: 0.25rem;\n  font-weight: 500;\n}\n\n.launchpad-view__section {\n  margin-bottom: 1.35rem;\n}\n\n.launchpad-view__section:last-of-type {\n  margin-bottom: 0;\n}\n\n.launchpad-view__section-title {\n  margin: 0 0 0.75rem;\n  font-size: 0.8rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.08em;\n  color: #475569;\n  display: flex;\n  align-items: center;\n  gap: 0.5rem;\n}\n\n.launchpad-view__section-title i {\n  color: #0f766e;\n  font-size: 0.95rem;\n  opacity: 0.9;\n}\n\n.launchpad-view__code-block {\n  font-family: ui-monospace, \"SF Mono\", Menlo, monospace;\n  font-size: 0.78rem;\n  line-height: 1.5;\n  padding: 0.9rem 1rem;\n  background: #0f172a;\n  color: #e2e8f0;\n  border-radius: 12px;\n  word-break: break-all;\n  border: 1px solid #1e293b;\n  box-shadow: inset 0 1px 0 rgba(255, 255, 255, 0.06);\n}\n\n.launchpad-view__two-col {\n  display: grid;\n  grid-template-columns: 1fr 1fr;\n  gap: 1rem;\n}\n\n@media (max-width: 560px) {\n  .launchpad-view__two-col {\n    grid-template-columns: 1fr;\n  }\n}\n\n.launchpad-view__kv {\n  list-style: none;\n  margin: 0;\n  padding: 0;\n  background: #fff;\n  border-radius: 14px;\n  border: 1px solid #e2e8f0;\n  overflow: hidden;\n}\n\n.launchpad-view__kv li {\n  display: flex;\n  justify-content: space-between;\n  align-items: baseline;\n  gap: 1rem;\n  padding: 0.75rem 1rem;\n  border-bottom: 1px solid #f1f5f9;\n  font-size: 0.88rem;\n}\n\n.launchpad-view__kv li:last-child {\n  border-bottom: none;\n}\n\n.launchpad-view__kv span {\n  color: #64748b;\n  font-weight: 500;\n}\n\n.launchpad-view__kv em {\n  font-style: normal;\n  font-weight: 700;\n  color: #0f172a;\n  text-align: right;\n}\n\n.launchpad-view__pills-row {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.5rem;\n  margin-bottom: 0.75rem;\n}\n\n.launchpad-view__toggle {\n  font-size: 0.78rem;\n  font-weight: 600;\n  padding: 0.45rem 0.85rem;\n  border-radius: 999px;\n  background: #f1f5f9;\n  color: #64748b;\n  border: 1px solid #e2e8f0;\n}\n\n.launchpad-view__toggle.is-on {\n  background: linear-gradient(135deg, #ecfdf5, #d1fae5);\n  color: #047857;\n  border-color: #a7f3d0;\n}\n\n.launchpad-view__toggle i {\n  margin-right: 0.35rem;\n  opacity: 0.85;\n}\n\n.launchpad-view__vesting-cards {\n  display: grid;\n  grid-template-columns: repeat(4, 1fr);\n  gap: 0.5rem;\n}\n\n@media (max-width: 560px) {\n  .launchpad-view__vesting-cards {\n    grid-template-columns: repeat(2, 1fr);\n  }\n}\n\n.launchpad-view__vesting-card {\n  background: #fff;\n  border: 1px solid #e2e8f0;\n  border-radius: 12px;\n  padding: 0.65rem 0.75rem;\n  text-align: center;\n}\n\n.launchpad-view__vesting-card span {\n  display: block;\n  font-size: 0.65rem;\n  font-weight: 700;\n  text-transform: uppercase;\n  letter-spacing: 0.05em;\n  color: #94a3b8;\n  margin-bottom: 0.25rem;\n}\n\n.launchpad-view__vesting-card strong {\n  font-size: 1rem;\n  font-weight: 800;\n  color: #0f172a;\n}\n\n.launchpad-view__links {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 0.65rem;\n}\n\n.launchpad-view__link-btn {\n  display: inline-flex;\n  align-items: center;\n  gap: 0.5rem;\n  padding: 0.55rem 1.1rem;\n  font-size: 0.88rem;\n  font-weight: 600;\n  color: #0f766e;\n  background: #fff;\n  border: 1px solid #99f6e4;\n  border-radius: 12px;\n  text-decoration: none;\n  box-shadow: 0 2px 8px rgba(15, 118, 110, 0.12);\n  transition: transform 0.15s, box-shadow 0.2s, background 0.2s;\n}\n\n.launchpad-view__link-btn:hover {\n  background: #ecfdf5;\n  transform: translateY(-1px);\n  box-shadow: 0 6px 20px rgba(15, 118, 110, 0.2);\n}\n\n.launchpad-view__section--about .launchpad-view__about {\n  margin: 0;\n  font-size: 0.92rem;\n  line-height: 1.65;\n  color: #334155;\n  padding: 1rem 1.15rem;\n  background: #fff;\n  border-radius: 14px;\n  border: 1px solid #e2e8f0;\n  white-space: pre-wrap;\n}\n\n.launchpad-view__footer-meta {\n  display: flex;\n  flex-wrap: wrap;\n  gap: 1rem 1.5rem;\n  margin-top: 0.5rem;\n  padding-top: 1.25rem;\n  border-top: 1px dashed #cbd5e1;\n  font-size: 0.78rem;\n  color: #94a3b8;\n  font-weight: 500;\n}\n\n.launchpad-view__footer-meta i {\n  margin-right: 0.35rem;\n  color: #0f766e;\n  opacity: 0.8;\n}\n\n.launchpad-view__muted {\n  color: #94a3b8;\n  font-size: 0.88rem;\n}\n\n.launchpad-view__empty {\n  color: #64748b;\n  margin: 0;\n  padding: 2.5rem 1.5rem;\n  text-align: center;\n  font-size: 0.95rem;\n}\n\n.launchpad-view__actions {\n  flex-shrink: 0;\n  padding: 1rem 1.5rem 1.25rem;\n  background: linear-gradient(180deg, #f8fafc 0%, #fff 100%);\n  border-top: 1px solid #e2e8f0;\n  display: flex;\n  justify-content: flex-end;\n}\n\n.launchpad-view__btn-close {\n  padding: 0.65rem 1.75rem;\n  font-size: 0.9rem;\n  font-weight: 700;\n  font-family: inherit;\n  color: #fff;\n  background: linear-gradient(135deg, #0f766e 0%, #14b8a6 100%);\n  border: none;\n  border-radius: 12px;\n  cursor: pointer;\n  box-shadow: 0 4px 14px rgba(15, 118, 110, 0.35);\n  transition: transform 0.15s, box-shadow 0.2s, opacity 0.2s;\n}\n\n.launchpad-view__btn-close:hover {\n  transform: translateY(-1px);\n  box-shadow: 0 8px 24px rgba(15, 118, 110, 0.45);\n}\n\n.launchpad-view__btn-close:active {\n  transform: translateY(0);\n}\n\n@media (max-width: 576px) {\n  .launchpad-cards {\n    grid-template-columns: 1fr;\n  }\n\n  .launchpad-form__grid {\n    grid-template-columns: 1fr;\n  }\n\n  .launchpad-view-modal {\n    max-height: 100dvh;\n    border-radius: 0;\n    max-width: 100%;\n  }\n\n  .launchpad-view__hero-content {\n    flex-direction: column;\n    align-items: flex-start;\n    padding: 1.2rem 1.2rem 1.5rem;\n  }\n\n  .launchpad-view__title {\n    font-size: 1.35rem;\n  }\n\n  .launchpad-view__logo-wrap {\n    width: 72px;\n    height: 72px;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
